export default function setBreakpoints() {

  const mobile = '420px';
  const phablet = '768px';
  const tablet = '1024px';
  const desktop = '1280px';
  const tabletBefore = '1023px'
  const phabletBefore = '767px'

return {mobile, phablet, tablet, desktop, tabletBefore, phabletBefore}
}


